/**
 * Single resolver for `campLocations.providedByOrg` → `campOrganizations` document id.
 * Handles DocumentReference-shaped objects, legacy string paths, bare org id strings, and `{ path: "..." }`.
 */
export function resolveOrgIdFromProvidedByOrg(providedByOrg: unknown): string | null {
  if (providedByOrg == null) return null;

  if (typeof (providedByOrg as { id?: string }).id === "string") {
    const id = (providedByOrg as { id: string }).id.trim();
    if (id) return id;
  }

  if (typeof (providedByOrg as { path?: string }).path === "string") {
    const parts = String((providedByOrg as { path: string }).path).split("/").filter(Boolean);
    const idx = parts.indexOf("campOrganizations");
    if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
  }

  if (typeof providedByOrg === "string") {
    const parts = providedByOrg.split("/").filter(Boolean);
    const idx = parts.indexOf("campOrganizations");
    if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
    if (parts.length === 1) return parts[0];
    return parts[parts.length - 1] || null;
  }

  return null;
}
